<app-header-one></app-header-one>

<div class="page-title-area page-title-bg2">
    <div class="container">
        <div class="page-title-content">
            <h2>{{'Tracking_Application' | translate }}</h2>
        </div>
    </div>
</div>


    <fieldset [hidden]="!isDisabledSuccess">
        <section class="contact-area ptb-70 bg-light">
            <div class="container">



                <div class="card recent-orders-box">
                    <div class="card-body">

                        <div class="blog-details-desc text-center">
                            <div class="article-content">
                                <div class="entry-meta">
                                    <ul>
                                        <li>
                                            <i class='bx bx-globe'></i>
                                            <span>{{'Country' | translate }}</span>
                                            <a>{{ countryName }}</a>
                                        </li>
                                        <li>
                                            <i class='bx bx-calendar text-success'></i>
                                            <span>{{'Valid_from' | translate }}</span>
                                            <a>{{fromDate | date  : 'dd/MM/yyyy'}}</a>
                                        </li>
                                        <li>
                                            <i class='bx bx-time-five'></i>
                                            <span>{{'Stay_days' | translate }}</span>
                                            <a>{{ stayDays }}</a>
                                        </li>
                                        <li>
                                            <i class='bx bx-calendar text-danger'></i>
                                            <span>{{'Valid_to' | translate }}</span>
                                            <a>{{toDate | date  : 'dd/MM/yyyy'}}</a>
                                        </li>
                                        <li>
                                            <i class='bx bxs-file'></i>
                                            <span>{{'Order_No' | translate }}</span>
                                            <a>{{ orderNos }}</a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>



                <div class="card recent-orders-box" style="padding:15px">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-lg-8">

                                <h3>{{'Order_Details' | translate}}</h3>


                                <form autocomplete="off" #userlogin="ngForm">
                                    <div class="row">

                                        <div class="col-xs-12 col-12 col-md-6 form-group">
                                            <label>{{'Order_Date' | translate }}</label>
                                            <input type="text" class="form-control" name="arrivalDate" value="{{service.VWformData.arrivalDate | date  : 'dd/MM/yyyy'}}" disabled>
                                        </div>

                                        <div class="col-xs-12 col-12 col-md-6 form-group">
                                            <label>{{'Status' | translate }}</label>
                                            <input type="text" class="form-control" name="status" #status="ngModel" [(ngModel)]="service.VWformData.status" disabled>
                                        </div>

                                        <div class="col-xs-12 col-12 col-md-6 form-group">
                                            <label>{{'Visa_Type' | translate }}</label>
                                            <input type="text" class="form-control" name="visaTypeNameEn" #visaTypeNameEn="ngModel" [(ngModel)]="service.VWformData.visaTypeNameEn" disabled>
                                        </div>



                                        <div class="col-xs-12 col-12 col-md-6 form-group">
                                            <label>{{'Nationality' | translate }}</label>
                                            <input type="text" class="form-control" name="nationalityNameEn" #nationalityNameEn="ngModel" [(ngModel)]="service.VWformData.nationalityNameEn" disabled>
                                        </div>


                                        <div class="col-xs-12 col-12 col-md-6 form-group">
                                            <label>{{'Email' | translate }}</label>
                                            <input type="text" class="form-control" name="email" #email="ngModel" [(ngModel)]="service.VWformData.email" disabled>
                                        </div>


                                        <div class="col-xs-12 col-12 col-md-6 form-group" *ngIf="service.VWformData.status == 'Refund'">
                                            <label>{{'Refund_Amount' | translate }}</label>
                                            <input type="text" class="form-control" name="refundAmount" #refundAmount="ngModel" [(ngModel)]="service.VWformData.refundAmount" disabled>
                                        </div>


                                        <!--<div class="col-xs-12 col-12 col-md-6 form-group" *ngIf="service.VWformData.status == 'Refund'">
                <label>{{'Refund_Remark' | translate }}</label>
                <input type="text" class="form-control" name="refundRemark" #refundRemark="ngModel" [(ngModel)]="service.VWformData.refundRemark" disabled>
            </div>-->


                                    </div>
                                </form>

                                <div>
                                    <p style="font-weight:bold; color:darkred;">{{ closedVisaTXT }}</p>
                                    <button class="default-btnWhite" *ngIf="isDownloadVisa" style="margin: 20px" type="button" (click)="GoDownloadVisaBT()"> {{"Download_Visa" | translate }}</button>
                                    <button class="default-btnWhite" *ngIf="isDetails" style="margin: 20px" type="button" (click)="GoDetailsBT()"> {{"More_Details" | translate }}</button>

                                    <button class="default-btnWhite" *ngIf="isReferBack" type="button" (click)="GoReferBackBT()">{{'Refer_Back' | translate }}</button>
                                </div>



                            </div>


                            <div class="col-lg-4">
                                <a  target="_blank" href="https://www.google.com/search?sca_esv=7c2ca09b3e09a761&rlz=1C1GCEA_enRO1019AE1098&sxsrf=AHTn8zp-fartrEqamRjMr_ds6Q1YMsf9Fg:1746515218428&si=APYL9bs7Hg2KMLB-4tSoTdxuOx8BdRvHbByC_AuVpNyh0x2Kzb0GfN0elRdCAfEMPgWT1ZAv1p9mUin8W8ZgMrpw0BBst9RJ2UUN2a3GYAz0J-GV-27JKgwmGLkJVQ5tJjEuO4O57cjSx5JYamzDC4NlumzRACqt-A%3D%3D&q=Hekaya+Holidays+SPC+Reviews&sa=X&ved=2ahUKEwjmw8GZpI6NAxVZVPEDHXJnNOcQ0bkNegQIKxAE&biw=2133&bih=1050&dpr=0.9#lrd=0x3e8e6d721c04ded7:0xde70c01c0cd80024,3,,,,">
                                    <img src="../../../../../assets/img/HekayaGoogleReview.png" style="width:100%" />
                                </a>

                            </div>


                        </div>

                        

                    </div>
                </div>
            </div>
        </section>
    </fieldset>
